import { render, staticRenderFns } from "./SkillQuestion.vue?vue&type=template&id=7dde2439&scoped=true&"
import script from "./SkillQuestion.vue?vue&type=script&lang=js&"
export * from "./SkillQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SkillQuestion.vue?vue&type=style&index=0&id=7dde2439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dde2439",
  null
  
)

export default component.exports